import { useEffect, useRef, useState } from "react";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import moment from "moment";

import styles from "./MonthSelector.module.css";

const MONTHS = [
  "January", "February", "March",
  "April", "May", "June",
  "July", "August", "September",
  "October", "November", "December",
];

export const MonthSelector = ({ selectedDate, setSelectedDate }) => {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(moment(selectedDate).year());
  const ref = useRef(null);

  const selectedMonth = moment(selectedDate).month();
  const selectedYear = moment(selectedDate).year();

  useEffect(() => {
    setViewYear(selectedYear);
  }, [selectedYear]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleMonthClick = (monthIndex) => {
    setSelectedDate(new Date(viewYear, monthIndex, 1));
  };

  const minYear = moment().subtract(2, "years").year();
  const maxYear = moment().add(2, "years").year();

  return (
    <div className={styles.wrapper} ref={ref}>
      <button className={styles.trigger} onClick={() => setOpen((v) => !v)}>
        <span>{MONTHS[selectedMonth]}, {selectedYear}</span>
        <CalendarDays size={18} className={styles.icon} />
      </button>

      {open && (
        <div className={styles.dropdown}>
          <div className={styles.header}>
            <button
              className={styles.navBtn}
              onClick={() => setViewYear((y) => Math.max(y - 1, minYear))}
              disabled={viewYear <= minYear}
            >
              <ChevronLeft size={18} />
            </button>
            <span className={styles.year}>{viewYear}</span>
            <button
              className={styles.navBtn}
              onClick={() => setViewYear((y) => Math.min(y + 1, maxYear))}
              disabled={viewYear >= maxYear}
            >
              <ChevronRight size={18} />
            </button>
          </div>

          <div className={styles.grid}>
            {MONTHS.map((name, i) => {
              const isSelected = i === selectedMonth && viewYear === selectedYear;
              return (
                <button
                  key={name}
                  className={`${styles.monthBtn} ${isSelected ? styles.selected : ""}`}
                  onClick={() => handleMonthClick(i)}
                >
                  {name}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
